export enum AUTH_TAB {
	PHONE = 'phone',
	BANK_ACCOUNT = 'account',
	EMAIL = 'email',
	HELP = 'help',
	LOCAL = 'local',
	REGISTER = 'register'
}

export type AuthTabsType = {
	id: AUTH_TAB;
	name: string;
};
